import { render, staticRenderFns } from "./SwotAnalysis.vue?vue&type=template&id=49804a11&scoped=true"
import script from "./SwotAnalysis.vue?vue&type=script&lang=js"
export * from "./SwotAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49804a11",
  null
  
)

export default component.exports